import React from 'react';

import { FormattedMessage, useIntl } from '../../util/reactIntl';

import Modal from '../Modal/Modal';
import NamedLink from '../NamedLink/NamedLink';

import css from './ListingCapModal.module.css';

/**
 * Modal shown when a user has reached their open-listing limit.
 *
 * @param {Object} props
 * @param {string} props.id - The id of the modal
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - The function to close the modal
 * @param {Function} props.onManageDisableScrolling - The function to manage disable scrolling
 * @param {string} props.userTypeLabel - The user's account type label
 * @param {number} props.baseMax - The account type's base listing limit
 * @param {number} props.max - The user's effective listing limit
 * @param {boolean} props.isGroupBump - Whether forum groups increased the listing limit
 * @returns {JSX.Element} Listing cap modal
 */
const ListingCapModal = props => {
  const {
    id,
    isOpen,
    onClose,
    onManageDisableScrolling,
    userTypeLabel,
    baseMax,
    max,
    isGroupBump,
  } = props;
  const intl = useIntl();

  return (
    <Modal
      id={id}
      containerClassName={css.root}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={intl.formatMessage({ id: 'ListingCapModal.dismiss' })}
    >
      <p className={css.title}>
        <FormattedMessage id="ListingCapModal.title" />
      </p>
      <p className={css.body}>
        <FormattedMessage
          id={isGroupBump ? 'ListingCapModal.bodyWithGroupBump' : 'ListingCapModal.body'}
          values={{ userTypeLabel, baseMax, max }}
        />
      </p>
      <div className={css.actions}>
        <button className={css.dismissButton} type="button" onClick={onClose}>
          <FormattedMessage id="ListingCapModal.dismiss" />
        </button>
        <NamedLink className={css.manageListingsLink} name="ManageListingsPage" onClick={onClose}>
          <FormattedMessage id="ListingCapModal.viewListings" />
        </NamedLink>
      </div>
    </Modal>
  );
};

export default ListingCapModal;
